import { render, staticRenderFns } from "./SearchBar.vue?vue&type=template&id=36a3c425&scoped=true&"
import script from "./SearchBar.vue?vue&type=script&lang=js&"
export * from "./SearchBar.vue?vue&type=script&lang=js&"
import style0 from "./SearchBar.vue?vue&type=style&index=0&id=36a3c425&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36a3c425",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('36a3c425')) {
      api.createRecord('36a3c425', component.options)
    } else {
      api.reload('36a3c425', component.options)
    }
    module.hot.accept("./SearchBar.vue?vue&type=template&id=36a3c425&scoped=true&", function () {
      api.rerender('36a3c425', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/assets/js/Components/SearchBar.vue"
export default component.exports